import { FolderDetailView } from '@/features/AssetDetailView/FolderDetailView/FolderDetailView';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute(
    '/asset_collection/assets/$assetId/projects/$projectId/folders/$folderLetter/',
)({
    component: FolderDetailView,
});
